import { addMinutes, compareAsc, format as formatFn } from 'date-fns'

export type DateRangeProps = {
  startDate: string
  endDate: string
}

export const convertDateToUTC = (date: Date): Date => addMinutes(date, date?.getTimezoneOffset())

export const getDateRangeUTC = (range?: DateRangeProps): DateRangeProps => {
  return {
    startDate: formatRange(convertDateToUTC(new Date(range?.startDate)), 'yyyy-MM-dd'),
    endDate: formatRange(convertDateToUTC(new Date(range?.endDate)), 'yyyy-MM-dd'),
  }
}

export const formatRange = (date: Date | string, format = 'MMM d, yyyy'): string =>
  formatFn(date ? new Date(date) : new Date(), format)

export const getDateInPast = (days: number): Date => new Date(new Date().setDate(new Date().getDate() - days))

/*
 * [FYI]: set HH:mm need for correct showing UTC format
 * */
export const getDateRange = (days: number): DateRangeProps => ({
  startDate: formatRange(getDateInPast(days), 'yyyy-MM-dd HH:mm'),
  endDate: formatRange(new Date(), 'yyyy-MM-dd HH:mm'),
})

export const isLeftDateLessThanRightDate = (leftDate: Date | string, rightDate: Date | string): boolean =>
  compareAsc(new Date(leftDate), new Date(rightDate)) === -1

/*
 * [FYI]: set HH:mm need for correct showing UTC format
 * */
export const getValidatedDateRange = (range?: DateRangeProps): DateRangeProps => {
  const start = range?.startDate ? new Date(range.startDate) : getDateInPast(90)
  const end = range?.endDate ? new Date(range.endDate) : new Date()

  return {
    startDate: formatRange(isLeftDateLessThanRightDate(start, end) ? start : end, 'yyyy-MM-dd HH:mm'),
    endDate: formatRange(end, 'yyyy-MM-dd HH:mm'),
  }
}

export const getDateRangeFromQuery = (query: URLSearchParams | string): DateRangeProps => {
  const searchParams = new URLSearchParams(query)

  return getValidatedDateRange({
    startDate: searchParams?.has('startDate') ? searchParams?.get('startDate') : null,
    endDate: searchParams?.has('endDate') ? searchParams?.get('endDate') : null,
  })
}

export const getQueryStringToSetDateRangeToQuery = (query: URLSearchParams, range: DateRangeProps): string => {
  const searchParams = new URLSearchParams(query)

  searchParams?.set('startDate', range?.startDate || null)
  searchParams?.set('endDate', range?.endDate || null)

  return searchParams?.size > 0 ? searchParams?.toString() : ''
}
